import { createSlice } from "@reduxjs/toolkit";

// ----------------------------------------------------------------------

const initialState = {
    carrierList: [],
};

const slice = createSlice({
    name: "carrier",
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },

        stopLoading(state) {
            state.isLoading = false;
        },

        hasError(state, action) {
            state.isLoading = false;
            //
            state.error = action.payload;
        },

        clearError(state) {
            state.error = null;
        },

    }
});


// Reducer
export default slice.reducer;

// Actions
export const {
    clearError
} = slice.actions;
